
import * as AiIcons from "react-icons/ai";
import * as FaIcons from "react-icons/fa";

export const ContactItems = [
  /*
  {
    title: 'twitter',
    icon: <AiIcons.AiOutlineTwitter />,
    reference: ''
  },
  */
  {
    title: 'linkedin',
    icon: <AiIcons.AiOutlineLinkedin />,
    reference: 'https://www.linkedin.com/company/liveasygroup/'
  },
  {
    title: 'whatsapp',
    icon: <FaIcons.FaWhatsapp />,
    reference: 'https://wa.me/qr/WAL5O4YRIP3AL1'
  },
  /*{
    title: 'phone',
    icon: <AiIcons.AiOutlinePhone />,
    reference: 'tel:+2348038624907'
  },*/
  {
    title: 'mail',
    icon: <AiIcons.AiOutlineMail />,
    reference: 'mailto:liveasy200@gmail.com'
  }
]